<p-table
  #pt
  [value]="tasks"
  [paginator]="true"
  [rows]="25"
  [rowsPerPageOptions]="[25,100,200]"
  [lazy]="true"
  (onLazyLoad)="loadLazy($event)"
  [totalRecords]="recordTotal"
  [responsive]="true"
  sortMode="multiple"
  selectionMode="single"
  [(selection)]="task"
  dataKey="taskId"
  (onRowSelect)="onRowSelect($event)"
  [loading]="loading"> <ng-template pTemplate="caption"> <i
  class="fa fa-search"
style="margin:4px 4px 0 0;"></i> <!-- <input type="text" pInputText placeholder="Search" (input)="pt.filterGlobal($event.target.value, 'contains')" style="width:auto;"> -->
<div align="right">
  <button
    mat-raised-button
    color="primary"
  routerLink="/task-add">Add Task +</button>
</div>
</ng-template> <ng-template pTemplate="header">
<tr>
  @for (col of columns; track col) {
    <th
      [pSortableColumn]="col.field">{{col.header}} <p-sortIcon [field]="col.field"></p-sortIcon>
    </th>
  }
</tr>
<tr>
  @for (col of columns; track col) {
    <th
      >
      @switch (col.field) {@case ('status') {
        <p-multiSelect
          [options]="taskStatusOptions"
          defaultLabel="Status"
        (onChange)="pt.filter($event.value, col.field, 'in')"></p-multiSelect>
        } @case ('firstName') {
        <input
          pInputText
          type="text"
          (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
        } @case ('lastName') {
        <input
          pInputText
          type="text"
          (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
        } @case ('email') {
        <input
          pInputText
          type="text"
          (input)="pt.filter($event.target.value, col.field, col.filterMatchMode)">
        }}
      </th>
    }
  </tr>
</ng-template> <ng-template
pTemplate="body"
let-task>
<tr [pSelectableRow]="task">
  @for (col of columns; track col) {
    <td>{{task[col.field]}}</td>
  }
</tr>
</ng-template> <ng-template pTemplate="paginatorleft"> Showing {{recordTotal < 1 ? 0 : (lazyLoadEvent.first + 1)}} - {{recordTotal > 0 ? ((lazyLoadEvent.rows+ lazyLoadEvent.first) <= recordTotal ? (lazyLoadEvent.rows + lazyLoadEvent.first)
: recordTotal) : 0}} of {{recordTotal ? recordTotal : 0}} </ng-template> </p-table>
